import axios from '../../axiosConfig/axiosConfig';
import { clearAuthSession } from '../../lib/authSession';

function Logout() {
    const handleLogout = async (e) => {
        e?.preventDefault?.();
        try {
            await axios.post('/auth/logout');
        } catch (_err) {
            // Ignorado a propósito: igualmente se limpia sesión cliente.
        }
        clearAuthSession();
        // Recarga completa para que la app muestre la landing pública correctamente
        window.location.href = '/inicio';
    };

    return (
        <button type="button" onClick={handleLogout}>
            <i className="bi bi-box-arrow-left"></i> Cerrar Sesión
        </button>
    );
}

export default Logout;
